"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSameAs = exports.setBetween = exports.setBelow = exports.setAbove = exports["default"] = void 0;
var zIndexKeeper = 100;
var getIndex = function getIndex() {
  return _previous = zIndexKeeper += 25;
};
var _previous;
var setAbove = exports.setAbove = function setAbove(value) {
  if (!value) {
    value = _previous;
  }
  _previous = value + 1;
  return _previous;
};
var setBelow = exports.setBelow = function setBelow(value) {
  if (!value) {
    value = _previous;
  }
  _previous = value - 1;
  return _previous;
};
var setBetween = exports.setBetween = function setBetween(value1, value2) {
  _previous = parseInt(value1 + (value1 - value2) / 2);
  return _previous;
};
var setSameAs = exports.setSameAs = function setSameAs(value) {
  if (!value) {
    return _previous;
  }
  _previous = value;
  return _previous;
};
var zIndices = {
  dropDownMenu: getIndex(),
  modal: getIndex(),
  anchorModal: getIndex(),
  dropDownMenuModal: getIndex(),
  anchorModalContent: getIndex(),
  mobileDropDownMenu: getIndex()
};
var _default = exports["default"] = zIndices;